export default __webpack_public_path__ + "static/media/special-opportunities-fund-mobile.b392a136.webp";